import { AccordionContentProps } from '@radix-ui/react-accordion';
import MobileNavAccordionContentButton from 'src/components/Navigation/MobileNav/MobileNavAccordion/MobileNavAccordionContentButton';
import {
	MobileCategoryOption,
	NavigationState,
} from 'src/components/Navigation/types';
import { cj } from 'src/utils/classNames';

interface Props extends AccordionContentProps {
	navOption: MobileCategoryOption;
	handleNavigation: NavigationState['handleNavigation'];
}

export default function MobileNavAccordionContent({
	navOption,
	handleNavigation,
	className,
	...rest
}: Props) {
	return (
		<div
			className={cj(
				'-mx-lg divide-y divide-stroke-divider bg-container-bg',
				'overflow-hidden border-y border-stroke-divider',
				'data-[state=closed]:animate-accordion-slide-up data-[state=open]:animate-accordion-slide-down',
				className
			)}
			{...rest}
		>
			{navOption.options.map((categoryOption) => {
				return (
					<MobileNavAccordionContentButton
						key={categoryOption.name}
						categoryOption={categoryOption}
						handleNavigation={handleNavigation}
					/>
				);
			})}
		</div>
	);
}
